import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("g", {
  fill: "#e5e5e5",
  transform: "scale(3)"
}, ___EmotionJSX("path", {
  d: "M182.315 196.75v106.5h135.37v-106.5h-135.37zm124.465 94.953H193.864v-83.404H306.78v83.404z"
}), ___EmotionJSX("path", {
  d: "M199.715 282.865l23.373-24.57 8.759 3.793 27.63-29.427 10.881 13.015 4.904-2.965 26.565 40.154z"
}), ___EmotionJSX("circle", {
  cx: 226.719,
  cy: 229.417,
  r: 10.21
}));

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    viewBox: "0 0 500 500"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/image-placeholder.8880e22f.svg";
export { SvgComponent as ReactComponent };